import { useMutation } from "@tanstack/react-query";
import { dynamicNotification } from "src/utils/Notifications";

interface UseImportDataOptions<T> {
  mutationFn: (file: File) => Promise<T>;
  successMessage: string;
  errorMessage: string;
  onImportSuccess?: (data: T) => void;
}

const useImportData = <T>({
  mutationFn,
  successMessage,
  errorMessage,
  onImportSuccess,
}: UseImportDataOptions<T>) =>
  useMutation({
    mutationFn,
    onSuccess: (data) => {
      dynamicNotification(successMessage, "success");
      onImportSuccess?.(data);
    },
    onError: () => {
      dynamicNotification(errorMessage, "error");
    },
  });

export default useImportData;
